// required props
export interface IProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  match: any,
}

export enum Integrations {
  ZOOM = 'zoom',
}
